export default __webpack_public_path__ + "static/media/3401.8c0de739.jpg";